import React, { useState, useEffect } from 'react';
import { getMyProfile, submitVerificationDocuments } from '../../services/venueService';
import { uploadFile } from '../../services/uploadService';

const VerificationUpload = () => {
  const [profile, setProfile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getMyProfile().then(setProfile);
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setMessage('');
    try {
      const url = await uploadFile(file, 'verification-documents');
      const updated = await submitVerificationDocuments([{ type: 'business_document', url }]);
      setProfile(updated);
      setMessage('Document uploaded and submitted for review');
    } catch (err) {
      setMessage('Upload failed. Please try again.');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  if (!profile) return <p>Loading...</p>;

  const status = profile.verification.status;
  const statusColor = { pending: 'text-yellow-600', approved: 'text-green-600', rejected: 'text-red-600' }[status];

  return (
    <div className="bg-white p-6 rounded-lg shadow space-y-4">
      <p>Verification status: <span className={`font-semibold ${statusColor}`}>{status}</span></p>
      {status === 'rejected' && profile.verification.rejectionReason && (
        <p className="text-red-600 text-sm">Reason: {profile.verification.rejectionReason}</p>
      )}
      <div>
        <label className="block text-sm font-medium mb-1">Upload business registration / ownership document</label>
        <input type="file" accept="image/*,.pdf" onChange={handleFileChange} disabled={uploading} />
      </div>
      {uploading && <p className="text-sm text-gray-500">Uploading...</p>}
      {message && <p className="text-sm text-green-600">{message}</p>}
    </div>
  );
};

export default VerificationUpload;
